import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { shape, object, string, bool } from 'prop-types';
import { MODES, overflowHandler } from '../../../../utils';
import { ConfigMenuItemProps, ConfigLevelProps } from '../../../../types';
import {
    DIGITAL_MARKETING_CATEGORY_ID,
    PROGRAMMING_AND_TECH_CATEGORY_ID
} from '../../../../constants';
import AgenciesBannerPanel from '../../AgenciesBannerPanel';
import MenuBucket from '../../MenuBucket';
import MenuItem from '../../MenuItem';
import './index.scss';

const THREE_COLS_MIN_ITEMS = 20;
const FOUR_COLS_MIN_ITEMS = 30;

const columnClass = (itemsCount) => {

    if (itemsCount > FOUR_COLS_MIN_ITEMS) {
        return 'four-columns-menu';
    }

    if (itemsCount > THREE_COLS_MIN_ITEMS) {
        return 'three-columns-menu';
    }
};

const BucketPanel = ({ config, item, eventTracker, mode, isBriefButtonOnLeftVariation }) => {
    const [ overflowStyling, setOverflowStyling ] = useState({});
    const ref = useRef(null);
    const { level_2 = {}, level_3 = {} } = config;
    const buckets = level_2[item.id] || [];
    const categoryId = Number(item?.reportData?.categoryId);
    const showAgenciesBanner = categoryId === DIGITAL_MARKETING_CATEGORY_ID || categoryId === PROGRAMMING_AND_TECH_CATEGORY_ID;

    useEffect(() => {
        overflowHandler(ref, setOverflowStyling, isBriefButtonOnLeftVariation);
    }, [isBriefButtonOnLeftVariation]);

    const itemsCount = buckets.reduce((acc, bucket) => {
        const bucketItems = level_3[bucket.id] || [];
        return acc + bucketItems.length;
    }, 0);

    return (
        <ul ref={ref}
            className={classnames('menu-panel', columnClass(itemsCount), { 'has-agencies-banner': showAgenciesBanner })}
            style={overflowStyling}>
            {
                buckets && buckets.map((bucket) => (
                    <MenuBucket key={bucket.id} item={bucket} eventTracker={{ ...eventTracker, entry: bucket.displayName }}>
                        {
                            level_3[bucket.id] && level_3[bucket.id].map((item) => (
                                <MenuItem key={item.id}
                                    item={item}
                                    context={bucket.displayName}
                                    eventTracker={{ ...eventTracker, bucket: bucket.displayName, entry: item.displayName }}/>
                            ))
                        }

                    </MenuBucket>
                ))
            }
            { showAgenciesBanner &&
                <AgenciesBannerPanel eventTracker={eventTracker}
                    item={item}
                    isWide={itemsCount > THREE_COLS_MIN_ITEMS}
                    isPro={mode === MODES.PRO}/>
            }
        </ul>
    );
};

BucketPanel.propTypes = {
    config: shape({
        level_2: ConfigLevelProps,
        level_3: ConfigLevelProps
    }),
    item: ConfigMenuItemProps,
    eventTracker: object,
    mode: string,
    isBriefButtonOnLeftVariation: bool
};

export default BucketPanel;
